import type { Quote } from '../../vendor-dashboard/types/quote';
import { ACTION_TYPES, API_ENDPOINTS } from '../../vendor-dashboard/constants';
import apiFetch from '@wordpress/api-fetch';

const actions = {
    setQuotes( quotes: Quote[] ) {
        return {
            type: ACTION_TYPES.SET_QUOTES,
            quotes,
        };
    },

    setQuote( quote: Quote ) {
        return {
            type: ACTION_TYPES.SET_QUOTE,
            quote,
        };
    },

    setLoading( loading: boolean ) {
        return {
            type: ACTION_TYPES.SET_LOADING,
            loading,
        };
    },

    setHeaders( headers: Record< string, any > ) {
        return {
            type: ACTION_TYPES.SET_HEADERS,
            headers,
        };
    },

    approveQuote( quoteId: number, data: any ) {
        return async ( { dispatch } ) => {
            try {
                dispatch.setLoading( true );
                const path = API_ENDPOINTS.APPROVE.replace(
                    ':id',
                    quoteId.toString()
                );
                const response = await apiFetch( {
                    path,
                    method: 'POST',
                    data,
                } );
                dispatch.setQuote( response?.quote?.data );
                return response?.quote?.data;
            } catch ( error: any ) {
                // Handle error as needed, e.g., dispatch an error action
                throw error;
            } finally {
                dispatch.setLoading( false );
            }
        };
    },

    rejectQuote( quoteId: number ) {
        return async ( { dispatch } ) => {
            try {
                dispatch.setLoading( true );
                const path = API_ENDPOINTS.REJECT.replace(
                    ':id',
                    quoteId.toString()
                );
                const response = await apiFetch( { path, method: 'POST' } );
                dispatch.setQuote( response?.quote?.data );
                dispatch.setLoading( false );
                return response?.quote?.data;
            } catch ( error: any ) {
                throw error;
            }
        };
    },

    convertQuote( quoteId: number ) {
        return async ( { dispatch } ) => {
            try {
                dispatch.setLoading( true );
                const path = API_ENDPOINTS.CONVERT.replace(
                    ':id',
                    quoteId.toString()
                );
                const response = await apiFetch( { path, method: 'POST' } );
                dispatch.setQuote( response );
                dispatch.setLoading( false );
                return response;
            } catch ( error: any ) {
                throw error;
            }
        };
    },

    reopenQuote( quoteId: number ) {
        return async ( { dispatch } ) => {
            try {
                dispatch.setLoading( true );
                const path = API_ENDPOINTS.REOPEN.replace(
                    ':id',
                    quoteId.toString()
                );
                const response = await apiFetch( { path, method: 'POST' } );
                dispatch.setQuote( response?.quote?.data );
                dispatch.setLoading( false );
                return response?.quote?.data;
            } catch ( error: any ) {
                throw error;
            }
        };
    },

    batchUpdateQuotes( actionType: string, items: number[] ) {
        return async () => {
            try {
                const path = API_ENDPOINTS.BATCH;
                return await apiFetch( {
                    path,
                    method: 'POST',
                    data: { action: actionType, items },
                } );
            } catch ( error: any ) {
                throw error;
            }
        };
    },
};

export default actions;
